import React, { useState } from "react"
import { Collapse } from "reactstrap"
import { useDispatch } from "react-redux"
import classnames from "classnames"
import { TableValue } from "./manageTeamscols"
import { ActiveValue } from "pages/Admin/ManageUser/ManageUserCol"
import TableContainer from "components/Common/TableContainer"
import { approveTeam, endTeam, rejectTeam } from "store/createTeam/action"
import moment from "moment"
import RejectModal from "../../../../../src/components/Common/RejectModal"
import ApproveModal from "../../../../../src/components/Common/ApproveModal"
import EndModal from "../../../../../src/components/Common/EndModal"
import { Table, Row, Col, Button, Input } from "reactstrap"
import MobileResize from "common/Resize/MobileResize"
const Accordian = props => {
  const {
    activeTab,
    item,
    setselectedData,
    setIsEdit,
    toggle,
    setshowUserTable,
    setaccordionSelectedData,
    accordionSelectedData,
    userid,
    showUserTable,
    userColumns,
    setselectedid,
    selectedid,
    keyId,
    setAccordianColumn,
    accordianColumn,
    companySetting,
  } = props

  const [rejectModal, setRejectModal] = useState(false)
  const [approveModal, setApproveModal] = useState(false)
  const [endModal, setEndModal] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 921)

  const dispatch = useDispatch()
  const accordianColumn_toggle = value => {
    if (accordianColumn === value) {
      setAccordianColumn(null)
    } else {
      setAccordianColumn(value)
    }
  }
  const mergeData = item?.teamMembers?.map(el => ({
    active: el.active,
    reportToId: el.reportToId,
    reportToName: el.reportToName,
    supervisorid: el.supervisorid,
    supervisorname: el.supervisorname,
    userid: el.userid,
    username: el.username,
    categoryname: item.categoryname,
    supervisorname: item.supervisorname,
    subcategoryname: item.subcategoryname,
    durationList: el.durationList,
  }))

  const handleEditTeamAccordian = () => {
    const filterData = item?.teamMembers;
    setselectedData({ ...item, teamMembers: filterData });
    setIsEdit(true);
    toggle();
  }
  const handleApprove = () => {
    setApproveModal(true)
  }
  const handleEndTeam = () => {
    setEndModal(true)
  }
  const handleApprovel = () => {
    const teams = item.teamMembers
      .filter(el => !el.approved)
      .map(el => ({
        userId: el.userId,
        startDate: el?.startDate,
        endDate: el?.endDate,
      }))

    const approveParams = {
      categoryId: item.categoryid,
      subCategoryId: item.subcategoryid,
      reportTo: item.reportToId || item.teamMembers[0].reportToId,
      supervisorId: item.supervisorid,
      teammembers: teams,
      approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")
        ?.data?.id,
    }
    dispatch(approveTeam(approveParams))
    setApproveModal(false)
  }
  const handleEnd = () => {
    const teams = item?.teamMembers?.map(el => ({ userId: el.userId }))
    const endparams = {
      categoryId: item.categoryid,
      subCategoryId: item.subcategoryid,
      reportTo: item.reportToId || item.teamMembers[0].reportToId,
      supervisorId: item.supervisorid,
      teammembers: teams,
      endDate: moment(new Date()).format("YYYY-MM-DD"),
    }
    setEndModal(false)
    dispatch(endTeam(endparams))
  }

  const handleReject = () => {
    setRejectModal(true)
  }

  const handleRejectOrder = () => {
    // const teams = item.teamMembers.map(el => ({ userId: el.userid }))
    const teams = item.teamMembers
    const rejectParams = {
      categoryId: item.categoryid,
      subCategoryId: item.subcategoryid,
      reportTo: item.reportToId || item.teamMembers[0].reportToId,
      supervisorId: item.supervisorid,
      endDate: moment(new Date()).format("YYYY-MM-DD"),
      teammembers: teams,
      rejectByUserId: userid,
    }
    setRejectModal(false)
    dispatch(rejectTeam(rejectParams))
  }

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: companySetting?.MainCategory,
        accessor: "categoryname",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
      },

      {
        Header: companySetting?.SubCategory,
        disableFilters: true,
        accessor: "subcategoryname",
        filterable: true,
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
      },
      {
        Header: "User Name",
        accessor: "username",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
      },
      {
        Header: "Supervised",
        accessor: "supervisorname",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
      },
      {
        Header: "Reported",
        accessor: "reportToName",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "active",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <ActiveValue {...cellProps} />
        },
      },
    ]
    return result
  }, [activeTab])

  return (
    <React.Fragment>
      <RejectModal
        show={rejectModal}
        onDeleteClick={handleRejectOrder}
        onCloseClick={() => setRejectModal(false)}
        showText={"Are you sure want to Reject this team?"}
        confirmationText={"Yes, Reject"}
      />
      <ApproveModal
        show={approveModal}
        onDeleteClick={handleApprovel}
        onCloseClick={() => setApproveModal(false)}
      />
      <EndModal
        show={endModal}
        onDeleteClick={handleEnd}
        onCloseClick={() => setEndModal(false)}
      />
      <div className="accordion" id="accordion" key={keyId}>
        <div className="accordion-item mb-2">
          <div className="accordion-header custom_heading" id="headingOne">
            <button
              className={classnames("accordion-button zIndexes", "fw-medium", {
                collapsed: accordianColumn !== keyId,
              })}
              type="button"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setselectedid(null)
                setshowUserTable(false)
                accordianColumn_toggle(
                  `${item.categoryid}_${item.subcategoryid}_${item.supervisorid}`
                )
              }}
            >
              {item?.teamname}
            </button>
            {activeTab !== "3" && (
              <Col className="d-flex justify-content-end custom_button_accordian custom_hide_show">
                {activeTab !== "2" && (
                  <>
                    <div className="text-sm-end ">
                      <Button
                        type="button"
                        color="primary"
                        className="btn me-2"
                        onClick={handleApprove}
                      >
                        Approve
                      </Button>
                    </div>

                    <div className="text-sm-end ">
                      <Button
                        type="button"
                        color="primary"
                        className="btn me-2"
                        onClick={handleReject}
                      >
                        Reject
                      </Button>
                    </div>
                  </>
                )}

                <div className="text-sm-end ">
                  <Button
                    type="button"
                    color="primary"
                    className="btn me-2"
                    onClick={handleEditTeamAccordian}
                  >
                    Edit
                  </Button>
                </div>
                {activeTab === "2" && (
                  <div className="text-sm-end ">
                    <Button
                      type="button"
                      color="primary"
                      className="btn me-2"
                      onClick={handleEndTeam}
                    >
                      End Team
                    </Button>
                  </div>
                )}
              </Col>
            )}
          </div>

          <Collapse isOpen={accordianColumn === keyId} className="">
            <div className="accordion-body">
              <div className="text-muted table-mobileView">
                <MobileResize setIsMobile={setIsMobile}>
                  <TableContainer
                    data={mergeData || []}
                    columns={columns}
                    customPageSize={40}
                    isaccordianTeam={true}
                    handleEditTeamAccordian={handleEditTeamAccordian}
                    hidepagination={true}
                    activeTab={activeTab}
                    setshowUserTable={setshowUserTable}
                    setaccordionSelectedData={setaccordionSelectedData}
                    setselectedid={setselectedid}
                    selectedid={selectedid}
                  />
                </MobileResize>
                {showUserTable && (
                  <MobileResize setIsMobile={setIsMobile}>
                    <TableContainer
                      data={accordionSelectedData.durationList || []}
                      columns={userColumns}
                      customPageSize={40}
                      hidepagination={true}
                      selectedid={selectedid}
                    />
                  </MobileResize>
                )}
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </React.Fragment>
  )
}
export default Accordian
